import { useTranslation } from "react-i18next";
import { formatDate } from "@serie3/common/Shared/timeingStuff";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faFolderOpen } from "@fortawesome/free-solid-svg-icons";
import CompleteDropdown from "../../../shared/Dropdown/CompleteDropdown";

const FileListItem = ({
  file,
  index,
  deleteFile,
  viewFile,
  handleFileFunction = null,
  showPreview = false,
  dragable = false,
  moveFile = null,
  /** batch mode: a checkbox in front, the row toggles on click */
  selectable = false,
  selected = false,
  onToggleSelect = null,
}) => {
  const { t } = useTranslation();
  const toggle = selectable && typeof onToggleSelect === "function" ? onToggleSelect : null;
  return (
    <tr
      onClick={toggle ?? undefined}
      aria-selected={toggle ? selected : undefined}
      style={toggle ? { cursor: "pointer", background: selected ? "rgba(3,142,220,0.08)" : undefined } : undefined}
    >
      {selectable && (
        <td onClick={(e) => e.stopPropagation()}>
          <input
            type="checkbox"
            className="form-check-input"
            checked={selected}
            onChange={(e) => toggle && toggle(e.nativeEvent)}
            aria-label={file.original_name}
          />
        </td>
      )}
      <td>
        <button
          type="button"
          className="text-dark fw-medium btn btn-link p-0 text-start"
          onClick={(e) => {
            if (toggle) return; // the row handles it
            e.stopPropagation();
            if (typeof viewFile === "function") {
              viewFile(file);
            }
          }}
        >
          <i className="fas fa-file-alt align-middle text-primary me-3"></i>
          {file.original_name}
        </button>
      </td>
      <td>{formatDate(file.date)}</td>
      <td>{file.file_size}</td>
      <td onClick={(e) => e.stopPropagation()}>
        {!toggle && (
          <CompleteDropdown
            {...(deleteFile && { deleteAction: () => deleteFile(index, file) })}
            {...(viewFile && { viewAction: () => viewFile(file) })}
            addFront={true}
          >
            {typeof moveFile === "function" && (
              <Dropdown.Item onClick={() => moveFile(file)}>
                <FontAwesomeIcon icon={faFolderOpen} className="fs-6 me-2 text-warning" />
                {t("Backend.Files.Folders.Move", { defaultValue: "Move" })}
              </Dropdown.Item>
            )}
            {typeof handleFileFunction === "function" && (
              <>
                <Dropdown.Item
                  onClick={() => {
                    handleFileFunction(file);
                  }}
                  className="text-success"
                >
                  <FontAwesomeIcon icon={faPlus} className="fs-6 me-2" />
                  {t("Backend.Dropdown.Use")}
                </Dropdown.Item>
                <div className="dropdown-divider" />
              </>
            )}
          </CompleteDropdown>
        )}
      </td>
    </tr>
  );
};

export default FileListItem;
